(function(LIVEREZ, window) {
  LIVEREZ.constants = {
    MAP_TYPE: {
      google: 1,
      leaflet: 2,
    },
  };
})((window.LIVEREZ = window.LIVEREZ || {}), this);
